import 'flickity/dist/flickity.pkgd'
import axios from 'axios';

function initCanadaRegionMap() {
    const mapRoot = document.querySelector('.js-canada-region-map');

    if (!mapRoot || !mapRoot.dataset.regionMap) {
        return;
    }

    const entries = JSON.parse(mapRoot.dataset.regionMap);
    const tooltip = mapRoot.querySelector('.fp__by-region__map__tooltip');
    const canadaMap = mapRoot.querySelector('#canada_map');

    if (!canadaMap || !entries.length) {
        return;
    }

    const codeToEntry = {};

    entries.forEach((entry) => {
        entry.codes.forEach((code) => {
            codeToEntry[code] = entry;
        });
    });

    const getProvinceGroups = (code) => canadaMap.querySelectorAll(`:scope > g[id="${CSS.escape(code)}"]`);

    const getShapeGroups = (code) => Array.from(getProvinceGroups(code)).filter(
        (group) => !group.classList.contains('map__text')
    );

    const getFocusTarget = (entry) => {
        for (const code of entry.codes) {
            const shapes = getShapeGroups(code);

            if (shapes.length) {
                return shapes[0];
            }
        }

        return null;
    };

    const positionTooltipForEntry = (entry) => {
        if (!tooltip) {
            return;
        }

        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;

        entry.codes.forEach((code) => {
            getShapeGroups(code).forEach((group) => {
                const { left, top, right, bottom } = group.getBoundingClientRect();

                if (!left && !top && !right && !bottom) {
                    return;
                }

                minX = Math.min(minX, left);
                minY = Math.min(minY, top);
                maxX = Math.max(maxX, right);
            });
        });

        if (minX === Infinity) {
            return;
        }

        tooltip.style.left = `${(minX + maxX) / 2}px`;
        tooltip.style.top = `${minY}px`;
    };

    const navigateToEntry = (entry) => {
        if (entry?.url) {
            window.location.href = entry.url;
        }
    };

    const getProvinceGroupFromEvent = (event) => {
        let node = event.target;

        while (node && node !== canadaMap) {
            if (node.parentElement === canadaMap && codeToEntry[node.id]) {
                return node;
            }

            node = node.parentElement;
        }

        return null;
    };

    const clearHover = () => {
        canadaMap.querySelectorAll('g.is-hovered').forEach((group) => {
            group.classList.remove('is-hovered');
        });

        if (tooltip) {
            tooltip.hidden = true;
        }
    };

    const setHover = (entry) => {
        clearHover();

        if (!entry) {
            return;
        }

        entry.codes.forEach((code) => {
            getProvinceGroups(code).forEach((group) => {
                group.classList.add('is-hovered');
            });
        });

        if (tooltip) {
            tooltip.textContent = entry.label;
            tooltip.hidden = false;
        }
    };

    Object.keys(codeToEntry).forEach((code) => {
        getShapeGroups(code).forEach((group) => {
            group.style.cursor = 'pointer';
        });
    });

    const seenEntryIds = new Set();

    entries.forEach((entry) => {
        if (seenEntryIds.has(entry.id) || !entry.url) {
            return;
        }

        seenEntryIds.add(entry.id);

        const focusTarget = getFocusTarget(entry);

        if (!focusTarget) {
            return;
        }

        focusTarget.setAttribute('tabindex', '0');
        focusTarget.setAttribute('role', 'link');
        focusTarget.setAttribute('aria-label', entry.label);
    });

    canadaMap.addEventListener('mouseover', (event) => {
        const group = getProvinceGroupFromEvent(event);

        if (!group) {
            return;
        }

        const entry = codeToEntry[group.id];

        if (entry) {
            setHover(entry);
        }
    });

    canadaMap.addEventListener('mouseleave', clearHover);

    canadaMap.addEventListener('focusin', (event) => {
        const group = getProvinceGroupFromEvent(event);

        if (!group) {
            return;
        }

        const entry = codeToEntry[group.id];

        if (entry) {
            setHover(entry);
            positionTooltipForEntry(entry);
        }
    });

    canadaMap.addEventListener('focusout', (event) => {
        if (!canadaMap.contains(event.relatedTarget)) {
            clearHover();
        }
    });

    canadaMap.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') {
            return;
        }

        const group = getProvinceGroupFromEvent(event);

        if (!group) {
            return;
        }

        const entry = codeToEntry[group.id];

        if (entry?.url) {
            event.preventDefault();
            navigateToEntry(entry);
        }
    });

    canadaMap.addEventListener('click', (event) => {
        const group = getProvinceGroupFromEvent(event);

        if (!group) {
            return;
        }

        const entry = codeToEntry[group.id];

        if (entry) {
            navigateToEntry(entry);
        }
    });

    mapRoot.addEventListener('mousemove', (event) => {
        if (!tooltip || tooltip.hidden) {
            return;
        }

        tooltip.style.left = `${event.clientX}px`;
        tooltip.style.top = `${event.clientY}px`;
    });
}

function initHomepageHeroVideo() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const hero = document.querySelector('.homepage__hero')
    const wrapper = hero && hero.querySelector('.homepage__hero__video')

    if (!wrapper) {
        return
    }

    if (reduceMotion) {
        wrapper.remove()
        return
    }

    // Vimeo's background=1 embed plays itself. A self-hosted <video> does too,
    // but retry once in case it was inserted before autoplay was allowed.
    const video = wrapper.querySelector('video')

    if (video && video.paused) {
        const attempt = video.play()

        if (attempt && typeof attempt.catch === 'function') {
            attempt.catch(() => {})
        }
    }
}

jQuery(document).ready(function() {
    initCanadaRegionMap();
    initHomepageHeroVideo();
})
